import { Injectable } from '@angular/core';
import {
  HttpHandler,
  HttpInterceptor,
  HttpRequest,
  HttpEvent,
} from '@angular/common/http';
import { Observable, catchError, throwError } from 'rxjs';
import { Router } from '@angular/router';
import { AuthService } from '@shared/services/auth.service';
import { CommonService } from '@shared/services/common.service';

@Injectable()
export class BaseInterceptor implements HttpInterceptor {
  constructor(
    private authService: AuthService,
    private router: Router,
    private commonService: CommonService,
  ) {}

  intercept(
    req: HttpRequest<any>,
    next: HttpHandler,
  ): Observable<HttpEvent<any>> {
    const authReq = this.getRequest(req);
    return next.handle(authReq).pipe(
      catchError((err) => {
        const responseError = err.error;
        if (responseError.message === 'Unauthorized') {
          // Clear all open modals and loader when token expires
          this.commonService.clearAllModals();
          // Navigate to login page
          this.router.navigateByUrl('login');
        }

        return throwError(() => err);
      }),
    );
  }

  private getRequest(req: HttpRequest<any>) {
    const browserName = navigator.userAgent.toLowerCase().includes('chrome')
      ? 'Chrome'
      : navigator.userAgent.toLowerCase().includes('firefox')
      ? 'Firefox'
      : navigator.userAgent.toLowerCase().includes('safari')
      ? 'Safari'
      : navigator.userAgent.toLowerCase().includes('edge')
      ? 'Edge'
      : 'Unknown';

    const newHeaders: any = {
      'Content-Type': 'application/json',
      'X-Device-Id': this.authService.getDeviceId,
      'X-Device-Name': browserName,
    };

    // Add CSRF Token for mutating requests
    if (['POST', 'PUT', 'PATCH', 'DELETE'].includes(req.method)) {
      const csrfToken = this.getCookie('csrfToken');
      if (csrfToken) {
        newHeaders['X-CSRF-Token'] = csrfToken;
      }
    }

    const authReq = req.clone({
      setHeaders: newHeaders,
      withCredentials: true,
    });
    return authReq;
  }

  private getCookie(name: string): string | null {
    const match = document.cookie.match(new RegExp('(^| )' + name + '=([^;]+)'));
    if (match) {
      // Cookie is signed, format: s:value.signature
      const value = decodeURIComponent(match[2]);
      if (value.startsWith('s:')) {
        return value.substring(2).split('.')[0];
      }
      return value;
    }
    return null;
  }
}
